// extracted by mini-css-extract-plugin
module.exports = {"video":"rich-text-renderer_video__b05fv","rtParagraph":"rich-text-renderer_rtParagraph__9x5RV"};